module.exports = __webpack_public_path__ + "img/discount.2e507815.svg";